import {
  type ChartMetric, ChartMetricType,
} from '~/store/mapSettings/data/charts/mapSettingsCharts.types';
import type { ChartEditorModalContainerProps } from './chartEditorModal.container';

export const chartEditorMetricToChartMetric = (
  savedMetric: Parameters<ChartEditorModalContainerProps['onSave']>[0]['metrics'][number],
): ChartMetric | null => {
  if (savedMetric.type === ChartMetricType.SpreadsheetColumn && savedMetric.columnId && savedMetric.spreadsheetId) {
    return {
      type: ChartMetricType.SpreadsheetColumn,
      column: {
        columnId: savedMetric.columnId,
        spreadsheetId: savedMetric.spreadsheetId,
      },
    };
  }
  else if (savedMetric.type === ChartMetricType.Demographic && savedMetric.demographic) {
    return {
      type: ChartMetricType.Demographic,
      demographicId: savedMetric.demographic,
    };
  }
  else if (savedMetric.type === ChartMetricType.LocationCount && savedMetric.spreadsheetId) {
    return {
      type: ChartMetricType.LocationCount,
      spreadsheetId: savedMetric.spreadsheetId,
      ...(savedMetric.columnId && savedMetric.columnValue ? {
        column: {
          columnId: savedMetric.columnId,
          spreadsheetId: savedMetric.spreadsheetId,
        },
        columnValue: savedMetric.columnValue,
      } : {}),
    };
  }
  return null;
};
